import { RotationPlayerInfo } from '@/entities/rotations/RotationsInfo';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

interface RotationPlayerListProps {
	rotations: RotationPlayerInfo[];
	showBothPlayers?: boolean;
	title?: React.ReactNode;
	isEditMode?: boolean;
	isAwayTeam?: boolean;
}

export const RotationPlayerList = ({ title, rotations, showBothPlayers = true, isEditMode, isAwayTeam }: RotationPlayerListProps) => {
	const pathname = usePathname();
	const pathParts = pathname.split('/');

	const teamLeagueId = pathParts[2];
	const matchupId = pathParts[4];
	return (
		<div className="w-full max-w-[420px] min-w-[320px] max-h-[450px] overflow-y-auto p-6 flex flex-col rounded-3xl border border-gray-300 bg-white">
			<div className="flex flex-row items-center gap-4 justify-between">
				{title}
				{isEditMode && (
					<Link
						href={`/team-leagues/${teamLeagueId}/matchup/${matchupId}/tie-breaker?mode=edit&team=${isAwayTeam ? 'away' : 'home'}`}
						prefetch={false}
						className="text-darkorange-400 font-semibold cursor-pointer pb-4"
					>
						Edit
					</Link>
				)}
			</div>

			<div className="flex flex-col gap-4  max-w-full">
				{rotations?.map((player, index) => (
					<div key={player.playerOneUuid} className="flex items-center gap-3">
						<span className="w-6 h-6 flex items-center justify-center aspect-square rounded-full border border-gray-400 text-sm">
							{index + 1}
						</span>

						{showBothPlayers ? (
							<div className="flex flex-col w-full break-words leading-tight">
								<span>{player.playerOneName}</span>
								<span>{player?.playerTwoName}</span>
							</div>
						) : (
							<span className="w-full break-words leading-tight">{player.playerOneName}</span>
						)}
					</div>
				))}
			</div>
		</div>
	);
};
